<script setup lang="ts">
import { ref } from 'vue'
</script>

<template>
    <BaseContainer>
        <section
            class="bg-[#f5f7fa] lg:bg-white w-full bg-[url(/home/img/home/app-promotion-mobile.jpg)] lg:bg-[url(/home/img/home/app-promotion.png)] bg-contain bg-bottom lg:bg-center bg-no-repeat h-[900px] lg:h-[636px] my-8 lg:my-0">
            <div class="p-6 lg:pt-[132px] lg:pr-[120px]">
                <h2 class="text-center lg:text-right font-bold text-[32px] mb-4">
                    با
                    <span class="text-[#FFBA0E]">اپلیکیشن پی‌جیب</span>،
                    در چند دقیقه ارز جا‌به‌جا کنید
                </h2>
                <p class="text-center lg:text-right text-[#6C6C6C] text-lg mb-10">با اپلیکیشن پی‌جیب، در کمترین زمان و
                    با بیشترین امنیت تبادلات
                    ارزی خود را انجام دهید.
                </p>
                <div class="mb-8">
                    <div class="flex items-center font-bold text-[#6C6C6C] mb-4">
                        <img class="w-6 h-6 ml-3" src="/home/img/home/android-icon.svg" alt="" aria-hidden="true" />
                        <span class="text-sm">
                            دانلود برای اندروید
                        </span>
                    </div>
                    <div class="flex flex-col lg:flex-row items-start">
                        <UiButton href="https://play.google.com/store/apps/details?id=com.payjib" :link="true"
                            :external="true"
                            class="!bg-[#f5f7fa] hover:!bg-[#ffffff] text-lg font-bold items-center border-[#ABBAD5] mb-3 lg:ml-3"
                            :outlined="true">
                            <img class="w-6 h-6 ml-3" src="/home/img/home/playstore-icon.svg" alt=""
                                aria-hidden="true" />
                            <span>
                                دریافت از Play Store
                            </span>
                        </UiButton>
                        <button
                            class="flex items-center justify-center px-4 py-3 border bg-[#f5f7fa] border-[#B5B5B5] text-[#B5B5B5] rounded-lg font-bold"
                            disabled>
                            <img class="w-6 h-6 ml-3" src="/home/img/home/download-icon.svg" alt=""
                                aria-hidden="true" />
                            <span>
                                دانلود مستقیم (به زودی)
                            </span>
                        </button>
                    </div>
                </div>
                <div>
                    <div class="flex items-center font-bold text-[#6C6C6C] mb-4">
                        <img class="w-6 h-6 ml-3" src="/home/img/home/ios-icon.svg" alt="" aria-hidden="true">
                        <span class="text-sm">
                            دانلود برای iOS (آیفون)
                        </span>
                    </div>
                    <button
                        class="flex items-center justify-center px-4 py-3 border bg-[#f5f7fa] border-[#B5B5B5] text-[#B5B5B5] rounded-lg font-bold"
                        disabled>
                        <img class="w-6 h-6 ml-3" src="/home/img/home/pwa-icon.svg" alt="" aria-hidden="true">
                        <span>
                            دریافت (به زودی)
                        </span>
                    </button>
                </div>
            </div>
        </section>
    </BaseContainer>
</template>
